// extracted by mini-css-extract-plugin
export var container = "Modal-module--container--SlL0s";
export var backdrop = "Modal-module--backdrop--rMSfy";
export var contentAlign = "Modal-module--contentAlign--k+Gq5";
export var content = "Modal-module--content--afKRv";
export var closeButton = "Modal-module--closeButton--kfj8M";